const baseUrlDEPRECATED = '/api';
const baseUrl = '/api/v2';
/** Документы — только после входа (ЭЦП / eGov Mobile) и только участнику документа. */
export default ($axios) => {
    return {
        get_sign_data(guid) {
            return $axios.get(`${baseUrlDEPRECATED}/documents/${guid}/sled`);
        },
        // { document_guid, cms (главное вложение), attachments: [cms остальных по порядку] }
        sign(payload) {
            return $axios.post(`${baseUrlDEPRECATED}/documents/sign`, payload);
        },
        in_work_list() {
            return $axios.get(`${baseUrl}/documents/list/in-work`)
        },
        reviewed_list() {
            return $axios.get(`${baseUrl}/documents/list/reviewed`)
        },
        //form of {signed_xml:'',comment:''}
        review(guid,form){
            return $axios.post(`${baseUrl}/documents/${guid}/action/review`,form)
        },
        //form of {signed_xml:'',comment:''}
        reject_review(guid,form){
            return $axios.post(`${baseUrl}/documents/${guid}/action/reject-review`,form)
        },
        //form of {user_ids:''}
        set_reviewers(guid,form){
            return $axios.post(`${baseUrl}/documents/${guid}/action/set-reviewers`,form)
        },
        item_v2(guid) {
            return $axios.get(`${baseUrl}/documents/${guid}`);
        },
        // Файл вложения: сервер отдаёт его только участнику, поэтому — запросом с токеном.
        attachment_file(url, params = {}) {
            return $axios.get(url, { params, responseType: 'blob' });
        },
        // Подписание через eGov Mobile: сессия с QR и опрос её статуса.
        egov_start(guid) {
            return $axios.post(`${baseUrl}/documents/${guid}/egov`);
        },
        egov_status(guid, token) {
            return $axios.get(`${baseUrl}/documents/${guid}/egov/${token}`);
        },
    };
};
